export default class InMemoryFlatPanelDetectorManagerInitializer {
  constructor(detectorManager) {
    this.detectorManager = detectorManager;
  }

  init = () => this.detectorManager;

  get = () => this.detectorManager;
}
